import React, {Component} from 'react';

const zoneSelect = [
    { id: 1, zoneChoice: 1, name: 'Price Level 1', style: 'PL1' },
    { id: 2, zoneChoice: 2, name: 'Price Level 2', style: 'PL2' },
    { id: 3, zoneChoice: 3, name: 'Price Level 3', style: 'PL3' },
    { id: 4, zoneChoice: 4, name: 'Price Level 4', style: 'PL4' },
    { id: 5, zoneChoice: 5, name: 'Price Level 5', style: 'PL5' },
    { id: 6, zoneChoice: 6, name: 'Price Level 6', style: 'PL6' },
    { id: 7, zoneChoice: 7, name: 'Price Level 7', style: 'PL7' },
    { id: 8, zoneChoice: 8, name: 'Price Level 8', style: 'PL8' },
    { id: 9, zoneChoice: 9, name: 'Price Level 9', style: 'PL9' },
    { id: 10, zoneChoice: 10, name: 'Price Level 10', style: 'PL10' },
    { id: 11, zoneChoice: 11, name: 'Price Level 11', style: 'PL11' },
    { id: 12, zoneChoice: 12, name: 'Lottery', style: 'zoneLottery' },
    { id: 13, zoneChoice: 13, name: 'Not Sold', style: 'zoneNotSold' }
]

function Zones(props) {  
    return (
        <li className={props.zone.style}>
            <span onClick={props.onClick} className='zone'>{props.zone.zoneChoice}</span>
            <input defaultValue={props.zone.name} type='text' 
            onChange={props.onChange} size="17" ></input>
            <span className='totalSeats'></span>
        </li>
    )
}

class ZoneSelector extends Component {
    constructor(props) {
        super(props)
        this.state = {
            zones: zoneSelect
        }
        this.handleZoneClick = this.handleZoneClick.bind(this)
    }

    handleZoneClick(zone) {
        this.props.getUpdatedZone(zone.zoneChoice)
    }

    render() {
        const zoneList = this.state.zones.map(zone => 
            <Zones key={zone.id} zone={zone} 
                onClick={() => this.handleZoneClick(zone)}
                onChange={this.handleChange}
            />
        )
        return (
            <div>
                <ul className='zoneSelector'>
                    {zoneList}
                </ul>
            </div>
        )
    } 
}

export default ZoneSelector